import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFloorplan = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.826,4.951l-3.85,-2.653l-5.685,0l0,19.358l19.486,0l0,-19.358l-5.849,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.674,11.977l0,9.679",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.358,11.977l6.633,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.358,11.977l3.42,0",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		]
	})
});
export default SvgFloorplan;
